import React from "react";
import {
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableCaption,
  } from '@chakra-ui/react'

export default function Calculationtable(){
    return(
        <Table variant='striped' mx="auto" size='sm'>
        <TableCaption>(Голч ба кредит цагын үржвэрийг нийт кредит цагт хуваан таслалаас хойш 1 орны нарийвчлалтай авсан тоо)</TableCaption>
        <Thead>
          <Tr>
            <Th>Хичээлийн голч</Th>
            <Th></Th>
            <Th>Кредит</Th>
            <Th></Th>
            <Th>Үржвэр</Th>
          </Tr>
        </Thead>
        <Tbody>
          <Tr>
            <Td>3.1</Td>
            <Td>X</Td>
            <Td>3</Td>
            <Td>=</Td>
            <Td>9.3</Td>
          </Tr>
          <Tr>
            <Td>4.0</Td>
            <Td>X</Td>
            <Td>3</Td>
            <Td>=</Td>
            <Td>12</Td>
          </Tr>
          <Tr>
            <Td>2.7</Td>
            <Td>X</Td>
            <Td>3</Td>
            <Td>=</Td>
            <Td>8.1</Td>
          </Tr>
          <Tr>
            <Td>3.6</Td>
            <Td>X</Td>
            <Td>3</Td>
            <Td>=</Td>
            <Td>10.8</Td>
          </Tr>
          <Tr>
            <Td>1.4</Td>
            <Td>X</Td>
            <Td>2</Td>
            <Td>=</Td>
            <Td>4.2</Td>
          </Tr>
          <Tr>
            <Td></Td>
            <Td></Td>
            <Td>=</Td>
            <Td></Td>
            <Td>=</Td>
          </Tr>
          <Tr>
            <Td></Td>
            <Td></Td>
            <Td>14</Td>
            <Td></Td>
            <Td>44.4</Td>
          </Tr>
          <Tr>
            <Td></Td>
            <Td></Td>
            <Td></Td>
            <Td></Td>
            <Td></Td>
          </Tr>
          <Tr>
            <Td>44.4</Td>
            <Td>%</Td>
            <Td>14</Td>
            <Td>=</Td>
            <Td>3.1</Td>
          </Tr>
        </Tbody>
      </Table>
    )
}